module.exports = __webpack_public_path__ + "img/pleisure_bodyimage06-3.30523a44.jpg";